import React from "react";

const CartContext = React.createContext({
  cart: [],
  setCart: () => {},
  setValue: () => {},
});

export const CartProvider = CartContext.Provider;
export const CartConsumer = CartContext.Consumer;

export default CartContext;
